import { State } from "./State";
/**
 * This class extends the Map class to allow for state tracking
 * It notifies subscribers of key changes as if it where `stateProperties`.
 */
export class StateMap extends State {
    constructor() {
        super(...arguments);
        this.map = new Map();
    }
    get size() {
        this.recordRead();
        return this.map.size;
    }
    clear() {
        this.dispatchStateEvent();
        this.map.clear();
    }
    delete(key) {
        this.dispatchStateEvent(key.toString());
        return this.map.delete(key);
    }
    forEach(callbackfn, thisArg) {
        this.recordRead();
        this.map.forEach(callbackfn, thisArg);
    }
    get(key) {
        this.recordRead(key.toString());
        return this.map.get(key);
    }
    has(key) {
        this.recordRead(key.toString());
        return this.map.has(key);
    }
    set(key, value) {
        this.map.set(key, value);
        this.dispatchStateEvent(key.toString());
        return this;
    }
    entries() {
        this.recordRead();
        return this.map.entries();
    }
    keys() {
        this.recordRead();
        return this.map.keys();
    }
    values() {
        this.recordRead();
        return this.map.values();
    }
    [Symbol.iterator]() {
        this.recordRead();
        return this.map[Symbol.iterator]();
    }
    get [Symbol.toStringTag]() {
        return this.map[Symbol.toStringTag];
    }
}
//# sourceMappingURL=StateMap.js.map